// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Q4rB3","content":"style_content__6K8Uk","button":"style_button__MCj9J","title":"style_title__wqW4+","info":"style_info__QlRrr"};